import LanguageIcon from '@mui/icons-material/Language'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useRequestsStore } from '../../store/storeRequests'
import { useWrapperStore } from '../../store/storeWrapper'

export const WebSearchButton = ({ isDisabled }) => {
    const { setWebSearch, isWebSearch } = useWrapperStore((state) => state)
    const { requestDetail, updateRequest, isLoadingUpdateRequest } = useRequestsStore(
        (state) => state,
    )

    const handleChange = async () => {
        if (requestDetail) {
            await updateRequest(
                { threadId: requestDetail.id },
                {
                    deep_research_enabled: !requestDetail.deep_research_enabled,
                },
            )
        } else {
            setWebSearch(!isWebSearch)
        }
    }

    return (
        <Tooltip title="Включение и отключение поиска в Интернете">
            <IconButton
                sx={{
                    border: '1px solid #E5E5E7',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    '&:hover': {
                        border: '1px solid #E5E5E7',
                        background: (
                            requestDetail ? requestDetail.deep_research_enabled : isWebSearch
                        )
                            ? '#004B9F'
                            : '#F6F6F6',
                    },

                    background: (requestDetail ? requestDetail.deep_research_enabled : isWebSearch)
                        ? '#006CFD'
                        : 'none',
                }}
                disabled={isLoadingUpdateRequest || isDisabled}
                variant="text"
                color="primary"
                onClick={handleChange}>
                <LanguageIcon
                    sx={{
                        color: requestDetail
                            ? requestDetail.deep_research_enabled
                            : isWebSearch
                              ? '#fff'
                              : '',
                    }}
                />
            </IconButton>
        </Tooltip>
    )
}
